import React from "react";
import { BadgeCheck, Factory, ShieldCheck, Users, Zap, Cog } from "lucide-react";
import { whyChooseUs } from "../mock";

const iconMap = { BadgeCheck, Factory, ShieldCheck, Users, Zap, Cog };

export default function WhyChooseUs() {
  return (
    <section className="bg-cream bg-dotted py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">Why Choose Us</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Built On Trust &amp; Heat</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {whyChooseUs.map((w, i) => {
            const Icon = iconMap[w.icon] || BadgeCheck;
            return (
              <div key={i} className="lift-on-hover bg-white rounded-xl border border-neutral-200 px-4 py-6 flex flex-col items-center text-center">
                <div className="w-14 h-14 rounded-xl bg-orange-500/10 text-orange-500 flex items-center justify-center">
                  <Icon size={26} />
                </div>
                <h4 className="mt-4 font-display text-base uppercase">{w.title}</h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
